import { HERO_VALUES } from './fixtures/kestrelHero';
import { beat, unit } from './story';
import { SETTLES } from './tempo';
import { TYPE_NUMBER_MS, TYPE_SENTENCE_MS, typing } from './typewriter';

/**
 * "Complete": the pack's passport, a draft at 13 of 15 values, gets its last
 * two in the value drawer. The cursor opens the rated capacity row, types
 * 75.2 into the measurement input and saves; then the safety instructions
 * row, types them in English, switches the editor to German, types them
 * again and saves: 15 of 15, 100%. The `phone-*` beats are the public page
 * on the phone beside it (the page serves what is saved, so each value
 * lands there after its save): idle time for a story without a phone.
 * Page: the passport. Needs the drawer's editors (part `drawer`).
 */
export const COMPLETE = unit('complete', {
    page: 'passport',
    beats: [
        // A beat on the draft; the camera shows both empty rows if it must.
        beat('reveal', 1200),
        beat('point-measure', 400),
        // A press on "Add value": the drawer rises (typing waits until it is up).
        beat('open-measure', 800, { needs: 'drawer', settles: SETTLES.drawerIn }),
        ...typing('type-measure', HERO_VALUES.capacity, { first: 550, perChar: TYPE_NUMBER_MS }),
        beat('point-save-measure', 500),
        // A press on Save: the sheet falls, the row takes the value, the rail follows.
        beat('save-measure', 700, { settles: SETTLES.drawerOut }),
        beat('phone-measure', 350),
        beat('point-text', 250),
        beat('phone-measure-value', 650),
        beat('open-text', 200, { needs: 'drawer', settles: SETTLES.drawerIn }),
        ...typing('type-en', HERO_VALUES.safety.en, { first: 550, perChar: TYPE_SENTENCE_MS }),
        beat('point-de', 400),
        // A press on the DE tab: German becomes the language typed in.
        beat('press-de', 550, { settles: SETTLES.press }),
        ...typing('type-de', HERO_VALUES.safety.de, { first: 300, perChar: TYPE_SENTENCE_MS }),
        beat('point-save-text', 400),
        beat('save-text', 700, { settles: SETTLES.drawerOut }),
        beat('phone-text', 350),
        beat('phone-text-value', 800),
    ],
});
